import { OrderedMap } from 'immutable';
import {
    AJAX_AUTOCOMPLETE,
    AUTOCOMPLETE_CHECKBOX,
    DATE_OF_BIRTH,
    //DONT_KNOW_BTN,
    DROPDOWN,
    //CHECKBOX,
    //RADIO_BUTTONS,
    YES_NO_BUTTONS,
    //SLIDER,
    //SMALL_INPUT,
    //TEXT_INPUT,
    NUMBER_INPUT,
    MULTIBIRTH
    //WEIGHT,
    //HEIGHT
} from '../form.components/field.type.names.jsx';
import GENETIC_TESTS_LIST from '../config/genetic.tests.list.jsx';
import _ from '../i18n.jsx';
import { EMPTY_STRING } from '../questionnaire.utils.jsx';

export const SIBLING = 'SIBLING';
export const CHILDREN = 'CHILDREN';
export const NEPHEW = 'NEPHEW';
export const COUSIN = 'COUSIN';
export const UNCLE = 'UNCLE';

export const MALE = 'MALE';
export const FEMALE = 'FEMALE';

export const PATERNAL = 'PATERNAL';
export const MATERNAL = 'MATERNAL';
const YES = 'yes';
const NO = 'no';

export const relationGenderMap = {
    [SIBLING]   : { [MALE]: 'brother',  [FEMALE]: 'sister'      },
    [CHILDREN]  : { [MALE]: 'son',      [FEMALE]: 'daughter'    },
    [NEPHEW]    : { [MALE]: 'nephew',   [FEMALE]: 'niece'       },
    [COUSIN]    : { [MALE]: 'cousin',   [FEMALE]: 'cousin'      },
    [UNCLE]     : { [MALE]: 'uncle',    [FEMALE]: 'aunt'        },
    [`${UNCLE}_${MATERNAL}`]     : { [MALE]: 'uncle',    [FEMALE]: 'aunt'        },
    [`${UNCLE}_${PATERNAL}`]     : { [MALE]: 'uncle',    [FEMALE]: 'aunt'        }
};

export const parentRequiredRelations = { NEPHEW, COUSIN };

export const LOWER_CASE = 'LOWER_CASE';
export const UPPER_CASE = 'UPPER_CASE';
export const FIRST_CAP_CASE = 'FIST_CAP_CASE';

export function _isValidRelationOrGender(string) {
    if ('production' === process.env.NODE_ENV) { return { valid: true, error: null }; }
    if ('string' !== typeof string) {
        return {
            error: new TypeError('_validateRelationGenderString(): argument is not a string!'),
            valid: false
        };
    }
    if (EMPTY_STRING === string) {
        return {
            error: new Error('_validateRelationGenderString(): argument is EMPTY string!'),
            valid: false
        };
    }
    const _string = string.toUpperCase();
    if (_string in relationGenderMap) { return { valid: true, error: null }; }
    if (MALE === _string || FEMALE === _string) { return { valid: true, error: null }; }
    return { valid: false, error: new TypeError(`_validateRelationGenderString(): unknown value ${string}`) };
}

export function getRelationName(relationName, gender, caseFormat = LOWER_CASE) {
    const isValidRelation = _isValidRelationOrGender(relationName);
    const isValidGender = _isValidRelationOrGender(gender);
    if (!isValidRelation.valid) { throw isValidRelation.error; }
    if (!isValidGender.valid) { throw isValidGender.error; }
    const _relation = relationName.toUpperCase();
    const _gender = gender.toUpperCase();
    const relationString = relationGenderMap[_relation][_gender];
    switch (caseFormat) {
        case LOWER_CASE:
            return relationString.toLowerCase();
        case UPPER_CASE:
            return relationString.toUpperCase();
        case FIRST_CAP_CASE:
            return relationString[0].toUpperCase() + relationString.substr(1);
        default:
            throw new TypeError('getRelationName(): Unknown case format');
    }
}

function _showIfAlive(globalFields, localFields) { return YES === localFields.alive; }
function _showIfDead(globalFields, localFields) { return NO === localFields.alive; }

function _showIfTested(globalFields, localFields) { return YES === localFields.genetic_testing; }

export const genericSchema = {
    relationType: null,
    uncleType: null,
    parentRequired: false,
    name: EMPTY_STRING,
    gender: EMPTY_STRING,
    fields: new OrderedMap({
        alive: {
            order: 100,
            title: _('Is he/she alive?'),
            inputType: YES_NO_BUTTONS, props: { unknownAccepted: true }
        },
        dob: {
            order: 200,
            title: _('Date of birth'),
            inputType: DATE_OF_BIRTH,
            condition: _showIfAlive
        },
        diedAt: {
            order: 300,
            title: _('At what age did he/she die?'),
            inputType: NUMBER_INPUT, //add special field type
            props: { unknownAccepted: true, label: _('YEARS') },
            condition: _showIfDead
        },
        causeOfDeath: {
            order: 400,
            title: _('Cause of death'),
            inputType: AJAX_AUTOCOMPLETE,
            props: {
                placeholder: `${_('Example:')} ${_('Cancer')}`,
                title: _('Cause of death'),
                service: 'concept',
                conceptType: 'conditions',
                storageName: 'conditions',
                wrapperStyle: { display: 'block', marginBottom: 20 }
            },
            condition: _showIfDead
        },
        genetic_testing: {
            order: 500,
            title: _('Has she/he ever had genetic testing?'),
            inputType: YES_NO_BUTTONS,
            props: { unknownAccepted: true }
        },
        genetic_testing_list: {
            order: 510,
            inputType: AUTOCOMPLETE_CHECKBOX,
            title: _('For which genes?'),
            multipleChoice: true,
            unique: true,
            props: { variants: GENETIC_TESTS_LIST, defaultVariants: [ 1, 2, 3, 4, 5, 6 ], placeholder: _('Other, please describe') },
            condition: _showIfTested
        }
    })
};

export function getUncleType(relationType, uncleType) {
    if (UNCLE.toLowerCase() === relationType) {
        if (PATERNAL === uncleType || MATERNAL === uncleType) {
            return uncleType;
        }
        throw new TypeError(`getUncleType(): unknown uncle type: ${uncleType}`);
    }
    return null;
}

function _injectName(field, name) {  field.name = name; return field; }
//_order - shortcut for .sortBy
function _order({ order }) { return order; }

export function createSchema(relationType, extraFields = null, uncleType = null) {
    const _relationType = getRelationName(relationType, MALE);
    const overrideParams = {
        name: relationType,
        relationType: _relationType,
        parentRequired: relationType in parentRequiredRelations,
        uncleType: getUncleType(_relationType, uncleType)
    };
    if (null !== extraFields) {
        const _extraField = new OrderedMap(extraFields);
        const isAllExtraFieldsHasOrder = _extraField.every((field) => 'number' === typeof field.order);
        if (!isAllExtraFieldsHasOrder) {
            const notOrderedFields = _extraField.filter((field) => 'number' !== typeof field.order);
            console.log('Invalid schema fields');
            console.log(notOrderedFields.toJS());
            throw new TypeError('createSchema(): not all fields has order prop or is invalid');
        }
        overrideParams.fields = genericSchema.fields.merge(_extraField).sortBy(_order).map(_injectName).toArray();
    } else {
        overrideParams.fields = genericSchema.fields.sortBy(_order).map(_injectName).toArray();
    }
    return Object.assign({}, genericSchema, overrideParams);
}

function _showIfTwin(globalFields, localFields) { return YES === localFields.isTwin; }
function _showIfAdopted(globalFields, localFields) { return YES === localFields.isAdopted; }

export const siblingSchema = createSchema(SIBLING, {
    isTwin: {
        order: 410,
        title: _('Was he/she born a twin?'),
        inputType: YES_NO_BUTTONS,
        props: { unknownAccepted: true }
    },
    multibirth: {
        order: 411,
        inputType: MULTIBIRTH,
        condition: _showIfTwin,
        props: { withProband: true }
    },
    isAdopted: {
        title: _('Was he/she adopted?'),
        order: 440,
        inputType: YES_NO_BUTTONS,
        props: { unknownAccepted: true }
    },
    adoptedType: {
        title: _('Type:'),
        order: 441,
        inputType: DROPDOWN,
        props: { options: [
            { name: _('Unknown'), value: 'unknown' },
            { name: _('Paternal Half-Sibling'), value: 'paternal' },
            { name: _('Maternal Half-Sibling'), value: 'maternal' }
        ] },
        condition: _showIfAdopted
    }
});

export const childrenSchema = createSchema(CHILDREN, {
    isTwin: {
        order: 410,
        title: _('Was he/she born a twin?'),
        inputType: YES_NO_BUTTONS,
        props: { unknownAccepted: true }
    },
    multibirth: {
        order: 411,
        inputType: MULTIBIRTH,
        condition: _showIfTwin
    },
    isAdopted: {
        title: _('Was he/she adopted?'),
        order: 420,
        inputType: YES_NO_BUTTONS,
        props: { unknownAccepted: true }
    },
    spermEggDonor: {
        order: 430,
        title: _('Was he/she conceived by donor egg or sperm?'),
        inputType: YES_NO_BUTTONS,
        props: { unknownAccepted: true }
    }
});

export const nephewSchema = createSchema(NEPHEW);

export const paternalUncleSchema = createSchema(UNCLE, null, PATERNAL);

export const maternalUncleSchema = createSchema(UNCLE, null, MATERNAL);

export const cousinSchema = createSchema(COUSIN);

export const schemaMap = {
    [SIBLING]: siblingSchema,
    [CHILDREN]: childrenSchema,
    [NEPHEW]: nephewSchema,
    [COUSIN]: cousinSchema,
    [`${UNCLE}_${MATERNAL}`]: maternalUncleSchema,
    [`${UNCLE}_${PATERNAL}`]: paternalUncleSchema
};
